export function isValidHexCode(hexCode: string) {
  if (typeof hexCode !== 'string') {
    return false;
  }

  return /^#(?:[0-9a-fA-F]{3}){2}$/.test(hexCode.trim());
}
